import { cn } from "../lib/utils";
import * as React from "react";
import { LoadingBlock } from "./LoadingBlock";
const LABEL_WIDTHS = ["w-32", "w-48", "w-28", "w-40", "w-36"];
function DataTableLoadingSkeleton({ rows = 5, showSelectionColumn = true, showTrailingCell = false, className, ...props }) {
    return (React.createElement("div", { "aria-hidden": "true", className: cn("flex w-full flex-col", className), ...props }, Array.from({ length: rows }, (_, i) => (React.createElement("div", { key: i, className: "flex h-12 items-center gap-3 border-b border-separator px-2" },
        showSelectionColumn && (React.createElement(LoadingBlock, { className: "h-5 w-5 shrink-0 rounded-md" })),
        React.createElement(LoadingBlock, { className: cn("h-4", LABEL_WIDTHS[i % LABEL_WIDTHS.length]) }),
        showTrailingCell && (React.createElement(LoadingBlock, { className: "ml-auto h-5 w-24 rounded-full" })))))));
}
export { DataTableLoadingSkeleton };
//# sourceMappingURL=DataTableLoadingSkeleton.js.map